import * as React from "react";
import { useContext, useMemo } from "react";
import * as Immutable from "immutable";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import WidgetContext from "views/components/contexts/WidgetContext";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
const WidgetFieldTypesContextProvider = ({ children }) => {
  const { timerange, streams } = useContext(WidgetContext);
  const { data: fieldTypes } = useFieldTypes(streams, timerange);
  const fieldTypesContextValue = useMemo(() => {
    const fieldTypesList = Immutable.List(fieldTypes);
    return {
      all: fieldTypesList,
      currentQuery: fieldTypesList
    };
  }, [fieldTypes]);
  return /* @__PURE__ */ React.createElement(FieldTypesContext.Provider, { value: fieldTypesContextValue }, children);
};
export default WidgetFieldTypesContextProvider;
